import { BaseApiModel } from 'app/models/api/response';

export class TranslationGroup extends BaseApiModel {
    groupId = 0;
    name = '';
}
